import type { MealEntry, SupplementEntry } from '../types/mealTracking';
import demoBreakfast from '../assets/images/marketing_projects/cinta_natural/passo_01.jpg';
import demoLunch from '../assets/images/marketing_projects/cinta_natural/passo_02.jpg';
import demoSnack from '../assets/images/marketing_projects/cinta_natural/passo_03.jpg';
import demoDinner from '../assets/images/marketing_projects/cinta_natural/passo_04.png';

const DEMO_DAY = '2026-10-26';

export const MEAL_TRACKING_DEMO_DATE = DEMO_DAY;

export const createInitialMockMeals = (): MealEntry[] => [
  {
    id: 'meal-demo-1',
    date: DEMO_DAY,
    time: '07:30',
    categoryId: 'breakfast',
    customTitle: null,
    description: 'Aveia com banana e pasta de amendoim',
    photos: [{
      id: 'photo-demo-1',
      previewUrl: demoBreakfast,
      fileName: 'cafe-da-manha.jpg',
      isDemoAsset: true,
    }],
    createdAt: `${DEMO_DAY}T07:30:00.000Z`,
    updatedAt: `${DEMO_DAY}T07:30:00.000Z`,
  },
  {
    id: 'meal-demo-2',
    date: DEMO_DAY,
    time: '12:15',
    categoryId: 'lunch',
    customTitle: null,
    description: 'Arroz, feijão, frango grelhado e salada',
    photos: [{
      id: 'photo-demo-2a',
      previewUrl: demoLunch,
      fileName: 'almoco-1.jpg',
      isDemoAsset: true,
    }, {
      id: 'photo-demo-2b',
      previewUrl: demoSnack,
      fileName: 'almoco-2.jpg',
      isDemoAsset: true,
    }],
    createdAt: `${DEMO_DAY}T12:15:00.000Z`,
    updatedAt: `${DEMO_DAY}T12:15:00.000Z`,
  },
  {
    id: 'meal-demo-3',
    date: DEMO_DAY,
    time: '16:30',
    categoryId: 'afternoon_snack',
    customTitle: null,
    description: 'Iogurte com frutas',
    photos: [{
      id: 'photo-demo-3',
      previewUrl: demoSnack,
      fileName: 'lanche-tarde.jpg',
      isDemoAsset: true,
    }],
    createdAt: `${DEMO_DAY}T16:30:00.000Z`,
    updatedAt: `${DEMO_DAY}T16:30:00.000Z`,
  },
  {
    id: 'meal-demo-4',
    date: DEMO_DAY,
    time: '20:00',
    categoryId: 'dinner',
    customTitle: null,
    description: 'Sopa de legumes',
    photos: [{
      id: 'photo-demo-4',
      previewUrl: demoDinner,
      fileName: 'jantar.jpg',
      isDemoAsset: true,
    }],
    createdAt: `${DEMO_DAY}T20:00:00.000Z`,
    updatedAt: `${DEMO_DAY}T20:00:00.000Z`,
  },
];

export const createInitialMockSupplements = (): SupplementEntry[] => [
  {
    id: 'supplement-demo-1',
    name: 'Whey Protein',
    amount: '30',
    unitId: 'g',
    customUnit: null,
    date: DEMO_DAY,
    time: '08:00',
    frequencyId: 'after_training',
    customFrequency: null,
    brand: '',
    notes: '',
    createdAt: `${DEMO_DAY}T08:00:00.000Z`,
    updatedAt: `${DEMO_DAY}T08:00:00.000Z`,
  },
  {
    id: 'supplement-demo-2',
    name: 'Creatina',
    amount: '5',
    unitId: 'g',
    customUnit: null,
    date: DEMO_DAY,
    time: '12:30',
    frequencyId: 'daily',
    customFrequency: null,
    brand: '',
    notes: 'Com a refeição do almoço',
    createdAt: `${DEMO_DAY}T12:30:00.000Z`,
    updatedAt: `${DEMO_DAY}T12:30:00.000Z`,
  },
];
